var exports = {
  "z": "x620889e6--2a1173--root",
  "k": "x620889e6--2a1173--left",
};

module.exports = exports;
